import { bookingChangesContants } from '../../_constants';

export function bookingChange(state = {}, action) {
    switch (action.type) {
        case bookingChangesContants.RESET:
            return {}
        case bookingChangesContants.BOOKINGCHANGES_FETCHING:
            return {
                ...state,
                bookingChangesFetching: true,
            };
        case bookingChangesContants.BOOKINGCHANGES_FETCHED:
            return {
                ...state,
                bookingChangesFetching: false,
            };
        case bookingChangesContants.BOOKINGCHANGES_SUBMITTING:
            return {
                ...state,
                bookingChangesSubmitting: true,
            };
        case bookingChangesContants.BOOKINGCHANGES_SUBMITTED:
            return {
                ...state,
                bookingChangesSubmitting: false,
            };
        case bookingChangesContants.GET_BOOKINGREF:
            return {
                ...state,
                bookingData: action.bookingData,
            };
        case bookingChangesContants.GET_REVISION_LIST:
            return {
                ...state,
                revisionList: action.revisionList,
            };
        case bookingChangesContants.GET_REVISION_BY_ID:
            return {
                ...state,
                RevisionById: action.RevisionById,
            };
        case bookingChangesContants.GET_APPROVED_REVISION_BY_ID:
            return {
                ...state,
                getApprovedRevisionById: action.getApprovedRevisionById,
            };
        case bookingChangesContants.BOOKINGCHANGES_GENERATE_SI:
            return {
                ...state,
                BCSINumber: action.BCSINumber,
            };
        case bookingChangesContants.DOWNLOAD_APPROVED_BC:
            return {
                ...state,
                downloadAppr: action.downloadAppr,
            };
        default:
            return state;
    }
}